import apiClient from './apiClient';
import { GET_RESOURCE_BOOKING_BY_PACKAGE_NUMBER_URL } from './apiUrl';

const getResourceBookingByPackageNumberApi = () => {
  return apiClient.get(GET_RESOURCE_BOOKING_BY_PACKAGE_NUMBER_URL);
};

export { getResourceBookingByPackageNumberApi };
